/* eslint-disable react/prop-types */
import React from 'react';

/**
 * Presentational summary-card row for the pause-history detail pages (feature 027).
 * Reuses the shared au-card system — no new visual patterns.
 *
 * Props:
 *   cards — array of card descriptors, each either:
 *     { label, value, hint? }            → a single-value card (tnum value)
 *     { label, parts: [{ label, value }] } → a multi-line card (e.g. device split)
 *
 * A card is omitted when it is falsy or when a single-value card's `value` is
 * null/undefined — so a metric with no underlying column is never faked (FR-015).
 */
const isPresent = (v) => v !== null && v !== undefined && v !== '';

const PauseHistorySummaryCards = ({ cards = [] }) => {
  const visible = cards.filter((c) => c && (Array.isArray(c.parts) ? c.parts.length > 0 : isPresent(c.value)));
  if (visible.length === 0) return null;

  return (
    <div className="au-cards" data-testid="pause-history-summary">
      {visible.map((c) => (
        <div className="au-card" key={c.label}>
          <span className="au-card__label">{c.label}</span>
          {Array.isArray(c.parts) ? (
            <span className="au-card__value au-card__pair">
              {c.parts.map((p) => (
                <span className="au-card__def" key={p.label}>
                  {p.label} <b className="tnum">{p.value}</b>
                </span>
              ))}
            </span>
          ) : (
            <span className="au-card__value tnum">{c.value}</span>
          )}
          {isPresent(c.hint) ? <span className="au-card__sub">{c.hint}</span> : null}
        </div>
      ))}
    </div>
  );
};

export default PauseHistorySummaryCards;
